module.exports = __webpack_public_path__ + "static/media/icon-smile.ea3d6a73.svg";